"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIPublicGetResponse = exports.AIPublicGetResponseOperationId = void 0;
const ClientController_1 = require("../../../../../../ClientController");
exports.AIPublicGetResponseOperationId = 'AIPublicGetResponse';
/**
 * Retrieve a response that was generated by the AI via the public API
 *
 * @path /ai/public/responses/:responseId
 * @generated
 */
exports.AIPublicGetResponse = (0, ClientController_1.ClientControllerFactory)({
    path: '/ai/public/responses/:responseId',
    method: 'GET',
    definedStatusCodes: [200],
});
